import { Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import {
  CircularProgress,
  Tooltip,
  Select,
  MenuItem,
  FormControl,
  FormLabel,
  InputAdornment,
  TextField,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  Paper,
  TablePagination,
  Backdrop,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  FormHelperText,
  InputLabel,
  Box,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { postFormData } from "../services/http";
import { ContextSession } from "../services/ContextSession";
import FilterListIcon from "@mui/icons-material/FilterList";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import IconButton from "@mui/material/IconButton";
import Popover from "@mui/material/Popover";
import { useMediaQuery } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import CryptoJS from "crypto-js";
import dayjs from "dayjs";
import "dayjs/locale/es"; // Importa el archivo de localización para español
import sinaval from "./participante/archivos prestamo/sin aval.pdf";
import conaval from "./participante/archivos prestamo/con aval.pdf";
import consolidacion from "./participante/archivos prestamo/consolidacion.pdf";
import alivio from "./participante/archivos prestamo/alivio.pdf";
import terreno from "./participante/archivos prestamo/ADQUISICION DE TERRENO.pdf";
import vivienda from "./participante/archivos prestamo/ADQUISICION DE VIVIENDA.pdf";
import construccion from "./participante/archivos prestamo/CONSTRUCCION DE VIVIENDA.pdf";
import gravamen from "./participante/archivos prestamo/LIBERACION DE GRAVAMEN.pdf";
import mejoras from "./participante/archivos prestamo/MEJORAS O AMPLIACION DE VIVIENDA.pdf";
import otrosGarantia from "./participante/archivos prestamo/OTROS PRESTAMOS CON GARANTIA HIPOTECARIA.pdf";
dayjs.locale("es"); // Establece el idioma local a español

async function getSolicitudes(accesos, ip, id) {
  const formData = new FormData();
  formData.append("participante_id", id);

  let url = ip + "/api/resumenParticipante/";
  //let url = "https://be.injupemp.gob.hn:8443/api/resumenParticipante/";
 // let url = "http://127.0.0.1:8000/api/resumenParticipante/";
  let auto = "Bearer " + accesos;

  let response = await fetch(url, {
    method: "POST",
    body: formData,
    headers: {
      Authorization: auto,
    },
  });

  let datas = await response.json();
  console.log(datas);
  return Array.isArray(datas) ? datas : [];
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#19438C",
    color: "white",
    fontSize: 16,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
  "&:hover": {
    // Agrega estilo al pasar el cursor sobre la fila
    backgroundColor: "#C1C1C1", // Cambia el color de fondo al pasar el cursor
  },
}));

// CSS para los botones de acción
const actionButtonsCSS = `
    .action-buttons {
        display: flex;
        gap: 20px;
    }

    .action-buttons a:hover {
        opacity: 0.7; //Cambia la opacidad al pasar el cursor 
        cursor: pointer;  Cambia el cursor al pasar sobre los botones 
    }
`;

function MisSolicitudes() {
  let sessi = useContext(ContextSession);
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchTerm, setSearchTerm] = useState("");
  const [loanType, setLoanType] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [filas, setFilas] = useState([]);
  const [selectedTable, setSelectedTable] = useState("Preanálisis de Préstamo");
  //const dominio = "http://127.0.0.1:8000";
  const dominio = sessi.ip;
  // Clave secreta para la firma HMAC
  const secretKey =
    "django-insecure-8mo+j636(t*_cj&s&&3$7@*vwsk#yyl0u5fbv-v*^-)e!y&k#8";
  const [constanciasData, setConstanciasData] = useState([]);
  const [loadingPDF, setLoadingPDF] = useState(false);
  const [openObservacionesDialog, setOpenObservacionesDialog] = useState(false);
  const [observacionesSeleccionadas, setObservacionesSeleccionadas] = useState(
    [],
  );
  const [constanciaSeleccionada, setConstanciaSeleccionada] = useState(null);

  // Función para generar la firma HMAC
  const generarFirmaHMAC = (idUsuario) => {
    const query_string = `IdUsuarioParticipante=${idUsuario}`;
    const signature = CryptoJS.HmacSHA256(query_string, secretKey).toString(
      CryptoJS.enc.Hex,
    );
    return signature;
  };

  const tieneTexto = (value) =>
    value !== null && value !== undefined && String(value).trim() !== "";

  const isTruthyFlag = (value) =>
    value === true || value === 1 || value === "1";

  const isSubsanandoConstancia = (value) => isTruthyFlag(value);

  const cleanBase64 = (base64Str) => {
    if (!base64Str) return "";

    let normalizedBase64 = String(base64Str).trim();

    if (
      normalizedBase64.startsWith('"') &&
      normalizedBase64.endsWith('"')
    ) {
      normalizedBase64 = normalizedBase64.slice(1, -1);
    }

    if (normalizedBase64.startsWith("data:")) {
      const [, base64Content = ""] = normalizedBase64.split(",", 2);
      normalizedBase64 = base64Content;
    }

    return normalizedBase64
      .replace(/(\r\n|\n|\r)/gm, "")
      .replace(/\s+/g, "");
  };

  const getObservacionesConstancia = (constancia) => {
    if (!constancia) return [];

    const observaciones = [];

    if (
      isSubsanandoConstancia(constancia.subsanando) &&
      tieneTexto(constancia.observacionSubsanar)
    ) {
      observaciones.push({
        titulo: "Observación Subsanar",
        mensaje: constancia.observacionSubsanar,
      });
    }

    if (tieneTexto(constancia.observacionCancelada)) {
      observaciones.push({
        titulo: "Observación Cancelada",
        mensaje: constancia.observacionCancelada,
      });
    }

    if (tieneTexto(constancia.observacionFiltro)) {
      observaciones.push({
        titulo: "Observación Filtro",
        mensaje: constancia.observacionFiltro,
      });
    }

    if (constancia.estado === 5) {
      observaciones.push({
        titulo: "Observación",
        mensaje:
          "La constancia fue anulada porque pasó el tiempo máximo para realizar el pago.",
      });
    }

    return observaciones;
  };

  const handleTableChange = (event) => {
    setSelectedTable(event.target.value);
  };

  const [data, setData] = useState([]);

  useEffect(() => {
    // Obtener los datos del localStorage si existen
    const sessionData = JSON.parse(localStorage.getItem("sessionData"));

    if (sessionData) {
      sessi.sessionData = sessionData; // Restaurar los datos de sesión
    }

    // Función para obtener los datos de la API
    const fetchData = async () => {
      try {
        //const response = await fetch(`${sessi.ip}/api/quejasSugerencia/consultar/participante/`, {
        const response = await fetch(
          `${dominio}/api/quejasSugerencia/consultar/participante/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Authorization: `Bearer ${sessi.sessionData.token}`, // Se añade el token aquí
            },
            body: new URLSearchParams({
              participante_id: sessi.sessionData.id,
            }),
          },
        );
        const result = await response.json();
        // Mapea los datos a la estructura necesaria
        const mappedData = result.map((item) => ({
          ID: item.ID,
          numeroSolicitud: item.numerocorrelativo,
          nombreSolicitante: item.nombre_participante,
          tipoSolicitud: item.tipo === 1 ? "Queja" : "Sugerencia",
          fechaSolicitud: item.fecharegistro,
          estado: item.estado,
          tipoHipotecario: item.TipoHipotecario,
        }));
        setData(mappedData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [sessi.sessionData.id]);

  useEffect(() => {
    const sessionData = JSON.parse(localStorage.getItem("sessionData"));

    if (sessionData) {
      sessi.sessionData = sessionData;
    }

    async function fetchData() {
      let token = sessi.sessionData.token;
      const data = await getSolicitudes(token, sessi.ip, sessi.sessionData.id);
      setFilas(data);
      setLoading(false);
    }

    fetchData();
  }, []);

  useEffect(() => {
    const sessionData = JSON.parse(localStorage.getItem("sessionData"));

    if (sessionData) {
      sessi.sessionData = sessionData;
    }

    const fetchData = async () => {
      try {
        const token = sessi.sessionData.token;
        const data = await getSolicitudes(
          token,
          sessi.ip,
          sessi.sessionData.id,
        );
        if (data && data.length > 0) {
          setFilas(data);
        } else {
          console.error("Error: no se obtuvieron datos válidos.");
        }
      } catch (error) {
        console.error("Error al obtener datos:", error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [sessi.sessionData.id]);

  useEffect(() => {
    localStorage.setItem("sessionData", JSON.stringify(sessi.sessionData));
  }, [sessi.sessionData]);

  useEffect(() => {
    const fetchConstancias = async () => {
      if (selectedTable === "Constancias") {
        const signature = generarFirmaHMAC(sessi.sessionData.id);
        try {
          // const response = await fetch(
          //   `http://172.20.7.10:8082/api/ConstanciaPag/Usuario/?IdUsuarioParticipante=${sessi.sessionData.id}`,
          //   {
          const response = await fetch(
            `${dominio}/api/ConstanciaPag/Usuario/?IdUsuarioParticipante=${sessi.sessionData.id}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                "X-Signature": signature,
              },
            },
          );
          const result = await response.json();
          if (result && Array.isArray(result)) {
            setConstanciasData(
              result.map((item) => ({
                id_solicitud_constancia: item.id_solicitud_constancia,
                numeroSolicitud: item.numero_recibo,
                nombreSolicitante: sessi.sessionData.nombre || "No disponible",
                fechaSolicitud: item.fecha_registro?.slice(0, 10),
                monto: item.monto,
                idConstancia: item.fk_id_constancia,
                estado: item.fk_id_estado,
                subsanando: item.subsanando,
                recepcionOficina: item.recepcionOficina,
                oficinaEntregaParticipante: item.oficinaEntregaParticipante,
                observacionSubsanar: item.Observacion_subsanar,
                observacionCancelada: item.ObservacionCancelada,
                observacionFiltro: item.Observacion_filtro,
                documento: null, // Asume que no hay URL de documento aún
              })),
            );
          } else {
            console.error("Error: No se obtuvieron datos válidos.");
            setConstanciasData([]);
          }
        } catch (error) {
          console.error("Error al obtener los datos de la API:", error);
          setConstanciasData([]);
        }
      }
    };

    fetchConstancias();
  }, [selectedTable, sessi.sessionData.id]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSubSanarClick = (id, tipoconstancia) => {
    sessi.setVariable("IDSolicitudConstancia", id);

    if (tipoconstancia === 1) {
      // Obtiene el archivo correspondiente basado en el tipo hipotecario
      navigate("/Mis Solicitudes/SolicitudConstanciaHistorialSubsanar");
    } else if (tipoconstancia === 6 || tipoconstancia === 8) {
      navigate("/Mis Solicitudes/SolicitudConstanciaPrestacionesSubsanar");
    } else {
      navigate("/Mis Solicitudes/SolicitudConstanciaSubsanar");
    }
  };

  const handleOpenObservaciones = (constancia) => {
    const observaciones = getObservacionesConstancia(constancia);
    if (!observaciones.length) return;

    setConstanciaSeleccionada(constancia);
    setObservacionesSeleccionadas(observaciones);
    setOpenObservacionesDialog(true);
  };

  const handleCloseObservaciones = () => {
    setOpenObservacionesDialog(false);
    setConstanciaSeleccionada(null);
    setObservacionesSeleccionadas([]);
  };

  const navigate = useNavigate();

  const handleClick = (tipoPrestamo, tipoHipotecario) => {
    // Mapea los tipos de préstamo no hipotecarios a sus respectivos archivos
    const archivos = {
      "Sin Aval": sinaval,
      "Con Aval": conaval,
      "Alivio de Deuda": alivio,
      "Consolidación de Deuda": consolidacion,
    };

    // Mapea los tipos de préstamo hipotecarios a sus respectivos archivos
    const archivosHipotecarios = {
      "Compra de vivienda, condominio o apartamento": vivienda,
      "Compra de terreno": terreno,
      "Liberación de Gravamen Hipotecario": gravamen,
      "Construcción de vivienda": construccion,
      "Mejora de vivienda": mejoras,
      "Otros préstamos con garantía hipotecaria": otrosGarantia,
    };

    let archivo;

    if (tipoPrestamo === "Hipotecario") {
      // Obtiene el archivo correspondiente basado en el tipo hipotecario
      archivo = archivosHipotecarios[tipoHipotecario];
    } else {
      // Obtiene el archivo correspondiente basado en el tipo de préstamo no hipotecario
      archivo = archivos[tipoPrestamo];
    }

    if (archivo) {
      // Crea un enlace para descargar el archivo
      const link = document.createElement("a");
      link.href = archivo;
      link.download = archivo.split("/").pop(); // Extrae el nombre del archivo para el atributo download
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      console.error(
        "No se encontró un archivo para el tipo de préstamo o tipo hipotecario proporcionado.",
      );
    }
  };

  const handleClickCompleta = (id) => {
    sessi.setVariable("SolicitudPrestamo", id);
    navigate("/Mis Solicitudes/SolicitudesCarga");
  };

  const handleClickCarga = (id) => {
    sessi.setVariable("SolicitudPrestamo", id);
    navigate(`/Mis Solicitudes/SolicitudesCargaPreAnalisis`);
  };

  const handleClickCargaQueja = (id) => {
    sessi.setVariable("IDquejasugerencia", id);
    navigate(`/Mis Solicitudes/VerQuejasSugerencias`);
  };

  const handleSearchChange = (event) => {
    const searchTerm = event.target.value.toLowerCase();
    setSearchTerm(searchTerm);
  };

  const handleLoanTypeChange = (event) => {
    setLoanType(event.target.value);
  };

  const handleStatusChange = (event) => {
    setStatusFilter(event.target.value);
  };

  const filteredRows = Array.isArray(filas)
    ? filas.filter((row) => {
        const status =
          row.aprobado === 1
            ? "Aprobado"
            : row.aprobado === 2
              ? "Aprobado Sujeto A Cambios"
              : row.aprobado === 3
                ? "Rechazado"
                : "En Revisión";

        return (
          (row.TipoPrestamo?.includes(loanType) || loanType === "") &&
          (status.includes(statusFilter) || statusFilter === "") &&
          (searchTerm === "" ||
            (searchTerm &&
              (row.NumeroSolicitud?.toString().includes(searchTerm) ||
                (row.solicitante &&
                  row.solicitante[0] &&
                  (row.solicitante[0].Nombres?.toLowerCase().includes(
                    searchTerm,
                  ) ||
                    row.solicitante[0].Apellidos?.toLowerCase().includes(
                      searchTerm,
                    ))))))
        );
      })
    : [];

  // Estados para los filtros visibles
  const [anchorEl, setAnchorEl] = useState(null);
  const [filterType, setFilterType] = useState("");

  // Manejar el click en el botón de filtro
  const handleFilterClick = (event, type) => {
    setAnchorEl(event.currentTarget);
    setFilterType(type);
  };

  const handleFilterClose = () => {
    setAnchorEl(null);
    setFilterType("");
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const [openDialog, setOpenDialog] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const hoy = dayjs(); // Obtiene la fecha de hoy

  const shouldDisableDate = (date) => {
    // Deshabilita fechas pasadas
    if (date.isBefore(hoy, "day")) return true;

    // Deshabilita fechas después del día 20 de cada mes
    if (date.date() > 20) return true;

    // Deshabilita meses diferentes al mes actual
    if (date.month() !== hoy.month()) return true;

    return false;
  };

  const [selectedOption, setSelectedOption] = useState(
    "Preanálisis de préstamo",
  );
  const [loadingId, setLoadingId] = useState(null); // guarda el ID que está cargando

  const detectarTipoArchivo = (byteArray) => {
    const startsWith = (...bytes) =>
      bytes.every((byte, index) => byteArray[index] === byte);

    if (startsWith(0x25, 0x50, 0x44, 0x46)) {
      return { mime: "application/pdf", extension: "pdf" };
    }

    if (startsWith(0xff, 0xd8, 0xff)) {
      return { mime: "image/jpeg", extension: "jpg" };
    }

    if (startsWith(0x89, 0x50, 0x4e, 0x47)) {
      return { mime: "image/png", extension: "png" };
    }

    if (startsWith(0x47, 0x49, 0x46)) {
      return { mime: "image/gif", extension: "gif" };
    }

    if (
      startsWith(0x52, 0x49, 0x46, 0x46) &&
      byteArray[8] === 0x57 &&
      byteArray[9] === 0x45 &&
      byteArray[10] === 0x42 &&
      byteArray[11] === 0x50
    ) {
      return { mime: "image/webp", extension: "webp" };
    }

    if (startsWith(0x50, 0x4b, 0x03, 0x04)) {
      return {
        mime: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        extension: "docx",
      };
    }

    if (startsWith(0xd0, 0xcf, 0x11, 0xe0)) {
      return { mime: "application/msword", extension: "doc" };
    }

    return { mime: "application/octet-stream", extension: "bin" };
  };

  const getNombreArchivoConExtension = (fileName, extension) => {
    const nombreArchivo = fileName || "Constancia";
    return /\.[^/.]+$/.test(nombreArchivo)
      ? nombreArchivo.replace(/\.[^/.]+$/, `.${extension}`)
      : `${nombreArchivo}.${extension}`;
  };

  const descargarArchivoBase64 = (base64Content, fileName) => {
    const archivoBase64 = cleanBase64(base64Content);

    if (!archivoBase64) {
      return false;
    }

    const byteCharacters = atob(archivoBase64);
    const byteNumbers = Array.from(byteCharacters, (char) =>
      char.charCodeAt(0),
    );
    const byteArray = new Uint8Array(byteNumbers);
    const tipoArchivo = detectarTipoArchivo(byteArray);
    const blob = new Blob([byteArray], { type: tipoArchivo.mime });

    const link = document.createElement("a");
    const fileUrl = URL.createObjectURL(blob);

    link.href = fileUrl;
    link.download = getNombreArchivoConExtension(
      fileName,
      tipoArchivo.extension,
    );
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(fileUrl);

    return true;
  };

  const handleDownloadConstancia = async (row) => {
    const solicitudId = row.id_solicitud_constancia;

    try {
      setLoadingId(solicitudId);

      const secretKey =
        "django-insecure-8mo+j636(t*_cj&s&&3$7@*vwsk#yyl0u5fbv-v*^-)e!y&k#8";
      const queryString = `IdConstancia=${solicitudId}`;
      const signature = CryptoJS.HmacSHA256(queryString, secretKey).toString();

      // const response = await fetch(
      //   `http://172.20.7.10:8082/api/ConstanciaPag/Constancia/?${queryString}`,
      //   {

      const response = await fetch(
        `${dominio}/api/ConstanciaPag/Constancia/?${queryString}`,
        {
          method: "GET",
          headers: {
            "X-Signature": signature,
          },
        },
      );

      if (!response.ok) throw new Error("Error al obtener la constancia");

      const data = await response.json();

      const archivoDigital =
        data.ConstanciaEscaneadaDigital || data.constanciaEscaneadaDigital;
      const constanciaRecibidaEnOficina = isTruthyFlag(row.recepcionOficina);
      const archivoConstancia =
        constanciaRecibidaEnOficina || row.idConstancia === 1
          ? archivoDigital || data.constancia
          : data.constancia || archivoDigital;

      const pudoDescargar = descargarArchivoBase64(
        archivoConstancia,
        `Constancia_${solicitudId}`,
      );

      if (!pudoDescargar) {
        throw new Error("La constancia descargada no contiene un archivo válido");
      }
    } catch (error) {
      console.error("Error durante la descarga:", error);
      alert("Ocurrió un error al descargar la constancia");
    } finally {
      setLoadingId(null);
    }
  };

  return (
    //<div className="container" style={{ marginTop: 10 }}>
    <div style={{ marginTop: 10 }}>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "200px",
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <>
          <style>{actionButtonsCSS}</style>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              marginTop: isMobile ? 0 : 30,
            }}
          >
            <h2>
              <b>Mis Solicitudes</b>
            </h2>
          </div>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column" // Alinea el contenido verticalmente en el centro
          >
            <FormControl>
              <FormHelperText style={{ textAlign: "center" }}>
                Tipo de solicitud:
              </FormHelperText>

              <Select
                value={selectedTable}
                onChange={handleTableChange}
                style={{
                  marginBottom: "20px",
                  marginTop: "5px",
                  minWidth: "200px",
                }}
              >
                <MenuItem value="Preanálisis de Préstamo">
                  Preanálisis de Préstamo
                </MenuItem>
                <MenuItem value="Constancias">Constancias</MenuItem>
                <MenuItem value="Quejas y Sugerencias">
                  Quejas y Sugerencias
                </MenuItem>
              </Select>
            </FormControl>
          </Box>

          {selectedTable === "Preanálisis de Préstamo" && (
            <div className="row" style={{ marginTop: "20px" }}>
              <TableContainer component={Paper}>
                <Table style={{ fontSize: isMobile ? "7px" : "14px" }}>
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell
                        style={{
                          textAlign: "center",
                          fontSize: isMobile ? "7px" : "14px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <strong>No. Solicitud</strong>
                          <Tooltip title="Buscar por Solicitud" arrow>
                            <IconButton
                              onClick={(event) =>
                                handleFilterClick(event, "search")
                              }
                            >
                              <ManageSearchIcon style={{ color: "white" }} />
                            </IconButton>
                          </Tooltip>
                        </div>
                      </StyledTableCell>
                      {!isMobile && (
                        <StyledTableCell
                          style={{
                            textAlign: "center",
                            fontSize: isMobile ? "7px" : "14px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <strong>Nombre del Solicitante</strong>
                            {/*<Tooltip title="Buscar por Nombre" arrow>
                          <IconButton onClick={(event) => handleFilterClick(event, 'search')}>
                            <ManageSearchIcon style={{ color: 'white' }} />
                          </IconButton>
                        </Tooltip>*/}
                          </div>
                        </StyledTableCell>
                      )}
                      {!isMobile && (
                        <StyledTableCell
                          style={{
                            textAlign: "center",
                            fontSize: isMobile ? "7px" : "14px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <strong>Tipo De Préstamo</strong>
                            <Tooltip title="Filtrar por Tipo" arrow>
                              <IconButton
                                onClick={(event) =>
                                  handleFilterClick(event, "loanType")
                                }
                              >
                                <FilterListIcon style={{ color: "white" }} />
                              </IconButton>
                            </Tooltip>
                          </div>
                        </StyledTableCell>
                      )}
                      <StyledTableCell
                        style={{
                          textAlign: "center",
                          fontSize: isMobile ? "7px" : "14px",
                        }}
                      >
                        <strong>Fecha Solicitud</strong>
                      </StyledTableCell>
                      <StyledTableCell
                        style={{
                          textAlign: "center",
                          fontSize: isMobile ? "7px" : "14px",
                        }}
                      >
                        <strong>Estado</strong>
                      </StyledTableCell>
                      <StyledTableCell
                        style={{
                          textAlign: "center",
                          fontSize: isMobile ? "7px" : "14px",
                        }}
                      >
                        <strong>Acciones</strong>
                      </StyledTableCell>
                    </StyledTableRow>
                  </TableHead>

                  <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleFilterClose}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "center",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "center",
                    }}
                  >
                    {filterType === "search" && (
                      <TextField
                        placeholder="Ingrese el # de Solicitud"
                        aria-label="Search"
                        value={searchTerm}
                        onChange={handleSearchChange}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon />
                            </InputAdornment>
                          ),
                        }}
                      />
                    )}
                    {filterType === "loanType" && (
                      <FormControl>
                        <Select
                          value={loanType}
                          onChange={handleLoanTypeChange}
                          displayEmpty
                        >
                          <MenuItem value="">
                            <em>Todos los tipos</em>
                          </MenuItem>
                          <MenuItem value="Sin Aval">Sin Aval</MenuItem>
                          <MenuItem value="Con Aval">Con Aval</MenuItem>
                          <MenuItem value="Consolidacion de Deuda">
                            Consolidacion de Deuda
                          </MenuItem>
                          <MenuItem value="Alivio de Deuda">
                            Alivio de Deuda
                          </MenuItem>
                          <MenuItem value="Refinanciamiento">
                            Refinanciamiento
                          </MenuItem>
                        </Select>
                      </FormControl>
                    )}
                    {filterType === "status" && (
                      <FormControl>
                        <Select
                          value={statusFilter}
                          onChange={handleStatusChange}
                          displayEmpty
                        >
                          <MenuItem value="">
                            <em>Todos</em>
                          </MenuItem>
                          <MenuItem value="En Revisión">En Revisión</MenuItem>
                          <MenuItem value="Aprobado">Aprobado</MenuItem>
                          <MenuItem value="Rechazado">Rechazado</MenuItem>
                        </Select>
                      </FormControl>
                    )}
                  </Popover>
                  <TableBody>
                    {filteredRows.length > 0 ? (
                      (rowsPerPage > 0
                        ? filteredRows.slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage,
                          )
                        : filteredRows
                      ).map((row) => (
                        <StyledTableRow key={row.SolicitudID}>
                          <StyledTableCell
                            style={{
                              textAlign: "center",
                              fontSize: isMobile ? "7px" : "14px",
                            }}
                          >
                            {row.NumeroSolicitud !== null &&
                              row.NumeroSolicitud !== undefined &&
                              row.NumeroSolicitud}
                          </StyledTableCell>
                          {!isMobile && (
                            <StyledTableCell
                              style={{
                                textAlign: "center",
                                fontSize: isMobile ? "7px" : "14px",
                              }}
                            >
                              {row.solicitante &&
                                row.solicitante[0] &&
                                row.solicitante[0].Nombres &&
                                row.solicitante[0].Apellidos &&
                                `${row.solicitante[0].Nombres} ${row.solicitante[0].Apellidos}`}
                            </StyledTableCell>
                          )}
                          {!isMobile && (
                            <StyledTableCell
                              style={{
                                textAlign: "center",
                                fontSize: isMobile ? "7px" : "14px",
                              }}
                            >
                              {row.TipoPrestamo &&
                                row.TipoPrestamo !== null &&
                                row.TipoPrestamo !== undefined &&
                                row.TipoPrestamo +
                                  (row.TipoPrestamo === "Hipotecario" &&
                                  row.TipoHipotecario
                                    ? " (" + row.TipoHipotecario + ")"
                                    : "")}
                            </StyledTableCell>
                          )}
                          <StyledTableCell
                            style={{
                              textAlign: "center",
                              fontSize: isMobile ? "7px" : "14px",
                            }}
                          >
                            {row.FechaSolicitud !== null &&
                              row.FechaSolicitud !== undefined &&
                              row.FechaSolicitud.slice(0, 10)}
                          </StyledTableCell>
                          <StyledTableCell
                            style={{
                              textAlign: "center",
                              fontSize: isMobile ? "7px" : "14px",
                            }}
                          >
                            {row.aprobado === 1
                              ? "Pre Aprobado"
                              : row.aprobado === 2
                                ? "Pre Aprobado Sujeto A Cambios"
                                : row.aprobado === 3
                                  ? "Rechazado"
                                  : row.aprobado === 5
                                    ? "Aprobado"
                                    : row.aprobado === 6
                                      ? "Rechazado"
                                      : row.aprobado === 7
                                        ? "Aprobado Sujeto A Cambios"
                                        : "En Revisión"}
                          </StyledTableCell>
                          <StyledTableCell
                            style={{
                              textAlign: "center",
                              verticalAlign: "middle",
                            }}
                          >
                            <div
                              className="action-buttons"
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              {/*<Link onClick={() => setOpenDialog(true)} title="Ver Estado de la Sicitud" style={{ color: '#10ab80', margin: '0 1px' }}>
                              <i className="material-icons">&#xe922;</i>
                            </Link>*/}
                              <Link
                                onClick={() =>
                                  handleClickCarga(row.SolicitudID)
                                }
                                title="Ver Preanálisis"
                                style={{ color: "#10ab80", margin: "0 1px" }}
                              >
                                <i className="material-icons">&#xE417;</i>
                              </Link>
                              {(row.aprobado === 1 || row.aprobado === 2) && (
                                <Link
                                  onClick={() =>
                                    handleClick(
                                      row.TipoPrestamo,
                                      row.TipoHipotecario,
                                    )
                                  }
                                  title={
                                    row.TipoPrestamo === "Hipotecario"
                                      ? "Descargar Requisitos"
                                      : "Descargar Solicitud"
                                  }
                                  style={{ color: "#10ab80", margin: "0 1px" }}
                                >
                                  <i className="material-icons">&#xf000;</i>
                                </Link>
                              )}
                              {/*(row.aprobado >= 4) && (
                              <Link onClick={() => handleClickCompleta(row.SolicitudID)} title="Ver Solicitud Completa" style={{ color: '#10ab80', margin: '0 1px' }}>
                                <i className="material-icons">&#xf1c5;</i>
                              </Link>
                            )*/}

                              <Dialog
                                open={openDialog}
                                onClose={() => setOpenDialog(false)}
                                sx={{
                                  "& .MuiDialog-container": {
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  },
                                  "& .MuiPaper-root": {
                                    width: "500px", // Ajusta el ancho según tus necesidades
                                    height: "300px", // Ajusta la altura según tus necesidades
                                    maxWidth: "calc(100% - 40px)", // Asegura que el dialog no se desborde
                                  },
                                }}
                              >
                                <DialogTitle textAlign={"center"}>
                                  Seleccione fecha para agendar su cita
                                </DialogTitle>
                                <DialogContent
                                  sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    height: "calc(100% - 64px - 48px)", // Ajusta el espacio disponible para el contenido
                                  }}
                                >
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <DatePicker
                                      value={selectedDate}
                                      onChange={(date) => setSelectedDate(date)}
                                      shouldDisableDate={shouldDisableDate} // Aplica las restricciones de fecha
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          sx={{
                                            width: "300px", // Ajusta el ancho del DatePicker según tus necesidades
                                          }}
                                        />
                                      )}
                                    />
                                  </LocalizationProvider>
                                </DialogContent>
                                <DialogActions
                                  sx={{
                                    justifyContent: "center",
                                    padding: "16px", // Ajusta el padding según tus necesidades
                                  }}
                                >
                                  <Button
                                    sx={{
                                      backgroundColor: "#ECECEC",
                                      color: "black",
                                      "&:hover": {
                                        backgroundColor: "#8c8c8c",
                                        color: "white",
                                      },
                                      margin: "0 8px", // Espaciado entre botones
                                    }}
                                    onClick={() => {
                                      //guardar la cita
                                      setOpenDialog(false);
                                      setSelectedDate(null);
                                    }}
                                  >
                                    Cancelar
                                  </Button>
                                  <Button
                                    sx={{
                                      backgroundColor: "#ECECEC",
                                      color: "black",
                                      "&:hover": {
                                        backgroundColor: "#8c8c8c",
                                        color: "white",
                                      },
                                      margin: "0 8px", // Espaciado entre botones
                                    }}
                                    onClick={() => {
                                      //guardar la cita
                                      setOpenDialog(false);
                                      // console.log(`La fecha es: ${selectedDate.toString()}`)
                                    }}
                                  >
                                    Guardar
                                  </Button>
                                </DialogActions>
                              </Dialog>
                            </div>
                          </StyledTableCell>
                        </StyledTableRow>
                      ))
                    ) : (
                      <StyledTableRow>
                        <StyledTableCell
                          colSpan={8}
                          style={{
                            textAlign: "center",
                            fontSize: isMobile ? "7px" : "14px",
                          }}
                        >
                          No se encontraron solicitudes de preanálisis de
                          préstamo
                        </StyledTableCell>
                      </StyledTableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              {filteredRows.length > 0 && (
                <TablePagination
                  rowsPerPageOptions={isMobile ? [3, 5, 10] : [5, 10, 20]}
                  component="div"
                  count={filas.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  labelRowsPerPage={isMobile ? "Filas:" : "Filas por página"}
                  labelDisplayedRows={({ from, to, count }) =>
                    `${from} - ${to} de ${count}`
                  }
                />
              )}
            </div>
          )}

          {selectedTable === "Quejas y Sugerencias" && (
            //LA SEGUNDA TABLA COMIENZA AQUÍ
            <TableContainer component={Paper}>
              <Table style={{ fontSize: isMobile ? "7px" : "14px" }}>
                <TableHead>
                  <StyledTableRow>
                    <StyledTableCell
                      style={{
                        textAlign: "center",
                        fontSize: isMobile ? "7px" : "14px",
                      }}
                    >
                      <strong>No. Solicitud</strong>
                    </StyledTableCell>
                    {!isMobile && (
                      <StyledTableCell
                        style={{
                          textAlign: "center",
                          fontSize: isMobile ? "7px" : "14px",
                        }}
                      >
                        <strong>Nombre del Solicitante</strong>
                      </StyledTableCell>
                    )}
                    {!isMobile && (
                      <StyledTableCell
                        style={{
                          textAlign: "center",
                          fontSize: isMobile ? "7px" : "14px",
                        }}
                      >
                        <strong>Tipo de Solicitud</strong>
                      </StyledTableCell>
                    )}
                    <StyledTableCell
                      style={{
                        textAlign: "center",
                        fontSize: isMobile ? "7px" : "14px",
                      }}
                    >
                      <strong>Fecha de Solicitud</strong>
                    </StyledTableCell>
                    <StyledTableCell
                      style={{
                        textAlign: "center",
                        fontSize: isMobile ? "7px" : "14px",
                      }}
                    >
                      <strong>Estado</strong>
                    </StyledTableCell>
                    <StyledTableCell
                      style={{
                        textAlign: "center",
                        fontSize: isMobile ? "7px" : "14px",
                      }}
                    >
                      <strong>Acciones</strong>
                    </StyledTableCell>
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  {data.length > 0 ? (
                    data.map((row, index) => (
                      <StyledTableRow key={row.ID}>
                        <StyledTableCell
                          style={{
                            textAlign: "center",
                            fontSize: isMobile ? "7px" : "14px",
                          }}
                        >
                          {row.numeroSolicitud}
                        </StyledTableCell>
                        {!isMobile && (
                          <StyledTableCell
                            style={{
                              textAlign: "center",
                              fontSize: isMobile ? "7px" : "14px",
                            }}
                          >
                            {row.nombreSolicitante}
                          </StyledTableCell>
                        )}
                        {!isMobile && (
                          <StyledTableCell
                            style={{
                              textAlign: "center",
                              fontSize: isMobile ? "7px" : "14px",
                            }}
                          >
                            {row.tipoSolicitud}
                          </StyledTableCell>
                        )}
                        <StyledTableCell
                          style={{
                            textAlign: "center",
                            fontSize: isMobile ? "7px" : "14px",
                          }}
                        >
                          {row.fechaSolicitud.slice(0, 10)}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{
                            textAlign: "center",
                            fontSize: isMobile ? "7px" : "14px",
                          }}
                        >
                          {row.estado}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{
                            textAlign: "center",
                            verticalAlign: "middle",
                          }}
                        >
                          <div
                            className="action-buttons"
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <Link
                              title="Ver Solicitud"
                              onClick={() => handleClickCargaQueja(row.ID)}
                              style={{ color: "#10ab80", margin: "0 1px" }}
                            >
                              <i className="material-icons">&#xE417;</i>
                            </Link>
                          </div>
                        </StyledTableCell>
                      </StyledTableRow>
                    ))
                  ) : (
                    <StyledTableRow>
                      <StyledTableCell
                        colSpan={6}
                        style={{
                          textAlign: "center",
                          fontSize: isMobile ? "7px" : "14px",
                        }}
                      >
                        No se encontraron solicitudes de Quejas y Sugerencias
                      </StyledTableCell>
                    </StyledTableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )}

          {selectedTable === "Constancias" && (
            <TableContainer component={Paper}>
              <Table style={{ fontSize: isMobile ? "7px" : "14px" }}>
                <TableHead>
                  <StyledTableRow>
                    {/* {!isMobile && (
                    <StyledTableCell style={{ textAlign: 'center', fontSize: isMobile ? '7px' : '14px' }}>
                      <strong>ID Constancia</strong>
                    </StyledTableCell>)} */}
                    <StyledTableCell
                      style={{
                        textAlign: "center",
                        fontSize: isMobile ? "7px" : "14px",
                      }}
                    >
                      <strong>No. Solicitud</strong>
                    </StyledTableCell>
                    {!isMobile && (
                      <StyledTableCell
                        style={{
                          textAlign: "center",
                          fontSize: isMobile ? "7px" : "14px",
                        }}
                      >
                        <strong>Nombre del Solicitante</strong>
                      </StyledTableCell>
                    )}
                    {!isMobile && (
                      <StyledTableCell
                        style={{
                          textAlign: "center",
                          fontSize: isMobile ? "7px" : "14px",
                        }}
                      >
                        <strong>Fecha de Solicitud</strong>
                      </StyledTableCell>
                    )}
                    <StyledTableCell
                      style={{
                        textAlign: "center",
                        fontSize: isMobile ? "7px" : "14px",
                      }}
                    >
                      <strong>Tipo Constancia</strong>
                    </StyledTableCell>
                    <StyledTableCell
                      style={{
                        textAlign: "center",
                        fontSize: isMobile ? "7px" : "14px",
                      }}
                    >
                      <strong>Estado</strong>
                    </StyledTableCell>
                    <StyledTableCell
                      style={{
                        textAlign: "center",
                        fontSize: isMobile ? "7px" : "14px",
                      }}
                    >
                      <strong>Acciones</strong>
                    </StyledTableCell>
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  {constanciasData.length > 0 ? (
                    constanciasData.map((row, index) => {
                      const isSubsanando = isSubsanandoConstancia(
                        row.subsanando,
                      );
                      const recepcionOficinaActiva = isTruthyFlag(
                        row.recepcionOficina,
                      );
                      const entregaEnOficinaParticipante = isTruthyFlag(
                        row.oficinaEntregaParticipante,
                      );
                      const puedeDescargarConstancia =
                        row.estado === 4 || recepcionOficinaActiva;
                      const puedeVerObservaciones =
                        getObservacionesConstancia(row).length > 0;

                      return (
                        <StyledTableRow key={index}>
                          {/* {!isMobile && (
                        <StyledTableCell style={{ textAlign: 'center', fontSize: isMobile ? '7px' : '14px' }}>
                          {row.id_solicitud_constancia}
                        </StyledTableCell>)} */}
                          <StyledTableCell
                            style={{
                              textAlign: "center",
                              fontSize: isMobile ? "7px" : "14px",
                            }}
                          >
                            {row.numeroSolicitud}
                          </StyledTableCell>
                          {!isMobile && (
                            <StyledTableCell
                              style={{
                                textAlign: "center",
                                fontSize: isMobile ? "7px" : "14px",
                              }}
                            >
                              {row.nombreSolicitante}
                            </StyledTableCell>
                          )}
                          {!isMobile && (
                            <StyledTableCell
                              style={{
                                textAlign: "center",
                                fontSize: isMobile ? "7px" : "14px",
                              }}
                            >
                              {row.fechaSolicitud}
                            </StyledTableCell>
                          )}
                          <StyledTableCell
                            style={{
                              textAlign: "center",
                              fontSize: isMobile ? "7px" : "14px",
                            }}
                          >
                            {row.idConstancia === 1
                              ? "Historial Cotizaciones"
                              : row.idConstancia === 2
                                ? "Razonada"
                                : row.idConstancia === 3
                                  ? "Saldos Proyectados"
                                  : row.idConstancia === 4
                                    ? "No Tener Préstamo Activo"
                                    : row.idConstancia === 5
                                      ? "Trámite Embajada"
                                      : [6, 8].includes(row.idConstancia)
                                        ? "Pago de Prestaciones"
                                        : "ID No Encontrado"}
                          </StyledTableCell>
                          <StyledTableCell
                            style={{
                              textAlign: "center",
                              fontSize: isMobile ? "7px" : "14px",
                            }}
                          >
                            {isSubsanando
                              ? "SUBSANAR"
                              : entregaEnOficinaParticipante
                                ? "ENTREGADA"
                                : recepcionOficinaActiva &&
                                    !entregaEnOficinaParticipante
                                  ? "LISTA PARA ENTREGA"
                                  : row.estado === 1
                                    ? "PENDIENTE DE PAGO"
                                    : row.estado === 2
                                      ? "PENDIENTE DE EMITIR"
                                      : row.estado === 3
                                        ? "CANCELADA"
                                        : row.estado === 4
                                          ? "EMITIDA"
                                          : row.estado === 5
                                            ? "ANULADA"
                                            : row.estado === 6
                                              ? "REVISIÓN"
                                              : "ID No Encontrado"}
                          </StyledTableCell>
                          <StyledTableCell
                            style={{
                              textAlign: "center",
                              fontSize: isMobile ? "7px" : "14px",
                            }}
                          >
                            <div
                              className="action-buttons"
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                minHeight: "24px",
                              }}
                            >
                              {loadingId === row.id_solicitud_constancia ? (
                                <CircularProgress size={24} />
                              ) : (
                                <>
                                  <Tooltip
                                    title={
                                      puedeDescargarConstancia
                                        ? "Descargar Constancia"
                                        : "Debe estar emitida, lista para entrega o entregada para descargar"
                                    }
                                    arrow
                                  >
                                    <span>
                                      <Link
                                        onClick={
                                          puedeDescargarConstancia
                                            ? () =>
                                                handleDownloadConstancia(
                                                  row,
                                                )
                                            : null
                                        }
                                        style={{
                                          color: "#10ab80",
                                          margin: "0 1px",
                                          pointerEvents: puedeDescargarConstancia
                                            ? "auto"
                                            : "none",
                                          opacity: puedeDescargarConstancia
                                            ? 1
                                            : 0.5,
                                          cursor: puedeDescargarConstancia
                                            ? "pointer"
                                            : "not-allowed",
                                        }}
                                      >
                                        <i className="material-icons">
                                          &#xf000;
                                        </i>
                                      </Link>
                                    </span>
                                  </Tooltip>

                                  {/* Segundo Tooltip - Ejemplo con diferentes propiedades */}
                                  <Tooltip
                                    title={
                                      isSubsanando
                                        ? "Subsanar Constancia"
                                        : "Debe estar habilitada para realizar Subsanación"
                                    }
                                    arrow
                                  >
                                    <span>
                                      <Link
                                        onClick={
                                          isSubsanando
                                            ? () =>
                                                handleSubSanarClick(
                                                  row.id_solicitud_constancia,
                                                  row.idConstancia,
                                                )
                                            : null
                                        }
                                        style={{
                                          color: "#10ab80",
                                          margin: "0 1px",
                                          pointerEvents: isSubsanando
                                            ? "auto"
                                            : "none",
                                          opacity: isSubsanando ? 1 : 0.5,
                                          cursor: isSubsanando
                                            ? "pointer"
                                            : "not-allowed",
                                        }}
                                      >
                                        <i className="material-icons">
                                          handyman
                                        </i>
                                      </Link>
                                    </span>
                                  </Tooltip>
                                  <Tooltip
                                    title={
                                      puedeVerObservaciones
                                        ? "Ver observaciones"
                                        : "No hay observaciones disponibles"
                                    }
                                    arrow
                                  >
                                    <span>
                                      <Link
                                        onClick={
                                          puedeVerObservaciones
                                            ? () => handleOpenObservaciones(row)
                                            : null
                                        }
                                        style={{
                                          color: "#10ab80",
                                          margin: "0 1px",
                                          pointerEvents: puedeVerObservaciones
                                            ? "auto"
                                            : "none",
                                          opacity: puedeVerObservaciones
                                            ? 1
                                            : 0.5,
                                          cursor: puedeVerObservaciones
                                            ? "pointer"
                                            : "not-allowed",
                                        }}
                                      >
                                        <i className="material-icons">
                                          info_outline
                                        </i>
                                      </Link>
                                    </span>
                                  </Tooltip>
                                </>
                              )}
                            </div>
                          </StyledTableCell>
                        </StyledTableRow>
                      );
                    })
                  ) : (
                    <StyledTableRow>
                      <StyledTableCell
                        colSpan={isMobile ? 4 : 6}
                        style={{
                          textAlign: "center",
                          fontSize: isMobile ? "7px" : "14px",
                        }}
                      >
                        No se encontraron constancias registradas.
                      </StyledTableCell>
                    </StyledTableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )}

          <Dialog
            open={openObservacionesDialog}
            onClose={handleCloseObservaciones}
            fullWidth
            maxWidth="sm"
          >
            <DialogTitle textAlign={"center"}>
              Observaciones de la constancia
              {constanciaSeleccionada?.numeroSolicitud
                ? ` ${constanciaSeleccionada.numeroSolicitud}`
                : ""}
            </DialogTitle>
            <DialogContent dividers>
              {observacionesSeleccionadas.map((observacion, index) => (
                <Box
                  key={`${observacion.titulo}-${index}`}
                  sx={{
                    mb: index === observacionesSeleccionadas.length - 1 ? 0 : 2,
                  }}
                >
                  <Typography
                    variant="subtitle2"
                    sx={{ color: "#19438C", fontWeight: 700, mb: 0.5 }}
                  >
                    {observacion.titulo}
                  </Typography>
                  <Typography variant="body2" sx={{ whiteSpace: "pre-line" }}>
                    {observacion.mensaje}
                  </Typography>
                </Box>
              ))}
            </DialogContent>
            <DialogActions sx={{ justifyContent: "center", p: 2 }}>
              <Button onClick={handleCloseObservaciones} variant="contained">
                Cerrar
              </Button>
            </DialogActions>
          </Dialog>
        </>
      )}
    </div>
  );
}

export default MisSolicitudes;
